import { getRegistration } from '~/services/bizzabo/registration.service';

export const validateEmailAndTicketId = (email, ticketId) => {
 if (!email || !ticketId) {
  throw createError({
   statusCode: 400,
   statusMessage: 'Bad Request',
   message: 'Email and ticketId are required',
  });
 }
};

// Utility function to check if registration exists and matches the email
export const checkRegistration = async (email, ticketId, token) => {
 const registration = await getRegistration(ticketId, token);

 if (!registration) {
  throw createError({
   statusCode: 404,
   statusMessage: 'Not Found',
   message: 'The provided ticket ID is not valid. Please check your ticket ID and try again.',
  });
 }

 if (registration.properties?.email?.toLowerCase() !== email.toLowerCase()) {
  throw createError({
   statusCode: 404,
   statusMessage: 'Not Found',
   message:
    'The provided email does not match the email associated with the ticket. Please enter the email you used during registration.',
  });
 }

 if (registration.validity !== 'valid') {
  throw createError({
   statusCode: 400,
   statusMessage: 'Bad Request',
   message: 'Your registration is not valid. Please contact support for assistance.',
  });
 }

 if (registration.status !== 'OK' && registration.status !== 'completed') {
  throw createError({
   statusCode: 400,
   statusMessage: 'Bad Request',
   message: 'Your registration is not complete. Please complete your registration before proceeding.',
  });
 }

 return registration;
};

export const checkRegistrationOpen = (registration) => {
 const currentDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
 console.log(`🍤 ~ checkRegistrationOpen ~ currentDate:`, currentDate);
 const vipRegistrationOpenDate = new Date(
  new Date('2024-08-20T10:45:00').toLocaleString('en-US', { timeZone: 'America/New_York' })
  // new Date('2024-08-19T19:00:00').toLocaleString('en-US', { timeZone: 'America/New_York' })
 );
 // Just use time string, don't double convert;
 const generalRegistrationOpenDate = new Date('2024-08-27T14:00:00');
 //  const generalRegistrationOpenDate = new Date(
 //   new Date('2024-08-27T11:00:00').toLocaleString('en-US', { timeZone: 'America/New_York' })
 //  );
 console.log(`🍤 ~ checkRegistrationOpen ~ generalRegistrationOpenDate:`, generalRegistrationOpenDate);
 const isVipPassHolder = registration?.ticketName?.toLowerCase()?.includes('vip');

 const whitelistedEmails = [
  'ootterness@hubspot.com',
  'saaver@hubspot.com',
  'cyabroudy@hubspot.com',
  'ikirsch@hubspot.com',
  'stjohnson@hubspot.com',
  'ggreene@thisismess.com',
  'developer@thisismess.com',
  'dmalieiev+demo2@thisismess.com',
 ];
 const blacklistedTicketTypes = ['hubspotter'];

 // Currently no support needed for whitelisted ticket types, but is easy to add
 // Just duplicate the blacklistedTicketTypes logic, but use 'whitelisted' instead
 const whitelistedTicketTypes = [];

 let allowRegistration = false;

 // First case update vipHolders
 if (isVipPassHolder) allowRegistration = 'vipHolder';

 // Second override with whitelisted emails
 for (const email of whitelistedEmails) {
  if (registration?.email.toLowerCase() === email) allowRegistration = 'whitelisted';
 }

 //  Third override with blacklisted ticket types
 for (const type of blacklistedTicketTypes) {
  if (registration.ticketName.toLowerCase().includes(type)) allowRegistration = 'blacklisted';
 }

 switch (allowRegistration) {
  case 'whitelisted':
   return true;
  case 'blacklisted':
   throw createError({
    statusCode: 400,
    statusMessage: 'Bad Request',
    message: 'Your ticket type is not eligible for seat reservations.',
   });
  case 'vipHolder':
   if (currentDate < vipRegistrationOpenDate) {
    throw createError({
     statusCode: 400,
     statusMessage: 'Bad Request',
     message:
      'Seat reservations will open on August 20 for VIP pass holders and August 27 for General Admission pass holders. Please check back then!',
    });
   } else {
    return true;
   }
  default:
   if (currentDate < generalRegistrationOpenDate) {
    console.log('GA Registration is not open yet');
    throw createError({
     statusCode: 400,
     statusMessage: 'Bad Request',
     message:
      'Seat reservations will open on August 20 for VIP pass holders and August 27 for General Admission pass holders. Please check back then!',
    });
   } else {
    console.log('GA Registration is open');
    return true;
   }
 }

 return false;
};
